// extracted by mini-css-extract-plugin
module.exports = {"formContent":"Joinee_formContent_1wblY"};